<template>
  <div class="page-with-top-bar">
    <div class="flex items-center justify-between w-full mb-4">
      <v-button
        color="grey"
        icon="arrow-left"
        class="mr-8"
        @click="$emit('back-to-kpi-pretable')"
        size="small"
      >
        {{ $t('back') }}
      </v-button>
      <v-button
        icon="calculator"
        @click="generateReport()"
        class="m-3"
      >
        {{ $t('export') }}
      </v-button>
    </div>
    <section>
      <!-- form add group -->
      <div v-if="isAddGroup">
        <form @submit.prevent="addKpiGroup">
          <v-input
            v-model="newGroup.name"
            label="Nombre"
            placeholder="Nombre del grupo"
            required
          ></v-input>
          <v-button type="submit">{{ $t('save') }}</v-button>
        </form>
      </div>

      <!-- form add activity -->
      <div v-if="isAddActivity">
        <form @submit.prevent="addKpiActivity">
          <!-- selext -->
          <v-select
          v-model="activitySelected"
          label="Actividad"
          placeholder="Seleccione una actividad"
          :options="activities"
          required
          >

        </v-select>
          <v-button type="submit">{{ $t('save') }}</v-button>
        </form>
      </div>

      <!-- table -->
      <div class="card p-2">
        <div v-if="loading" class="my-8 text-center">
          <scale-loader />
        </div>
        <!-- quitado por ahora la selección de columnas !!! TODO: O LIMPIAR O AÑADIR LAS NUEVAS COLUMNAS-->
        <!--
        <div class="mb-3" style="display: none;">
          <multiselect v-model="columnsSelected"
            :options="_columns"
            :multiple="true"
            :deselect-label="$t('multiselect_deselect_label')"
            :select-label="$t('multiselect_select_label')"
            :selected-label="$t('multiselect_selected_label')"
            :show-labels="true"
            :hide-selected="false"
            :limit-text="count => `y ${count} más`"
            label="title"
            track-by="title"
            :close-on-select="true" :clear-on-select="false" :preserve-search="true"
            :max-height="150"
            :allow-empty="true"
            :limit="limitShowColumnsSelect"
            @select="_HandleSelectItem"
            @remove="_HandleRemoveItem">
          </multiselect>
        </div>
        -->
      <div v-else>
        <div class="table-container mt-4">
          <table>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th colspan="6" class="uppercase">{{ $t('planning_data') }}</th>
                <th colspan="8" class="uppercase">{{ $t('measurements_and_progress_data') }}</th>
                <th colspan="2" class="uppercase">{{ $t('scheduled_baseline') }}</th>
                <th colspan="4" class="uppercase">{{ $t('current_real') }}</th>
                <th colspan="2" class="uppercase">{{ $t('objective_ratio_pending') }}</th>
              </tr>
            </thead>
            <thead>
              <tr>
                <th v-if="columns.group.visible" class="uppercase">{{ $t('group') }}</th> <!-- 0 A -->
                <th v-if="columns.subactivity.visible" class="uppercase">{{ $t('subactivity') }}</th> <!-- 1 B -->
                <th v-if="columns.subactivity.visible" class="uppercase">{{ $t('planned_start_date') }}</th> <!-- 2 C -->
                <th v-if="columns.subactivity.visible" class="uppercase">{{ $t('planned_end_date') }}</th> <!-- 3 D -->
                <th v-if="columns.subactivity.visible" class="uppercase">{{ $t('objective_end_date') }}</th> <!-- 4 E -->
                <th v-if="columns.duration.visible" class="uppercase">{{ $t('duration_weeks') }}</th> <!-- 5 F -->
                <th v-if="columns.days_elapsed.visible" class="uppercase">{{ $t('weeks_elapsed') }}</th> <!-- 6 G -->
                <th v-if="columns.assignment.visible" class="uppercase">{{ $t('assignments') }}</th> <!-- 7 H -->
                <th v-if="columns.unit.visible" class="uppercase">{{ $t('units') }}</th> <!-- 8 I -->
                <th v-if="columns.projected.visible" class="uppercase">{{ $t('projected') }}</th> <!-- 9 J -->
                <th v-if="columns.executed.visible" class="uppercase">{{ $t('executed') }}</th> <!-- 10 K -->
                <th v-if="columns.progress.visible" class="uppercase">{{ $t('current_progress_per_measurement') }}</th> <!-- 11 L -->

                <th :style="{ backgroundColor: '#C6EFCE', color: '#006100' }" class="uppercase">{{ $t('projected_per_subactivity') }}</th> <!-- 12 M -->
                <th :style="{ backgroundColor: '#C6EFCE', color: '#006100' }" class="uppercase">{{ $t('executed_per_subactivity') }}</th> <!-- 13 N -->
                <th :style="{ backgroundColor: '#C6EFCE', color: '#006100' }" class="uppercase">{{ $t('current_progress_per_subactivity') }}</th> <!-- 14 O -->

                <th class="uppercase">{{ $t('weekly_ratio_scheduled_baseline_per_measurement') }}</th> <!-- 15 P -->
                <th :style="{ backgroundColor: '#C6EFCE', color: '#006100' }" class="uppercase">{{ $t('weekly_ratio_scheduled_baseline_per_subactivity') }}</th> <!-- 16 Q -->
                <th class="uppercase">{{ $t('weekly_ratio_actual_real_per_measurement') }}</th> <!-- 17 R -->
                <th :style="{ backgroundColor: '#C6EFCE', color: '#006100' }" class="uppercase">{{ $t('weekly_ratio_actual_real_per_subactivity') }}</th> <!-- 18 S -->
                <th v-if="columns.end_date_estimated.visible" :style="{ backgroundColor: '#C6EFCE', color: '#006100' }"
                class="uppercase">{{ $t('estimated_end_date_by_current_ratio') }}</th> <!-- 19 T -->
                <th :style="{ backgroundColor: '#C6EFCE', color: '#006100' }" class="uppercase">{{ $t('estimated_delay_days') }}</th> <!-- 20 U -->
                <th v-if="columns.ratio_objective.visible" class="uppercase">{{ $t('weekly_ratio_objective_per_measurement') }}</th> <!-- 21 V -->
                <th v-if="columns.ratio_objective_subactivity.visible" :style="{ backgroundColor: '#C6EFCE', color: '#006100' }" class="uppercase">{{ $t('weekly_ratio_objective_per_subactivity') }}</th> <!-- 22 W -->
              </tr>
            </thead>
            <tbody>
              <template v-for="group in kpiData" >
                <template v-for="(subactivity, subIndex) in group.subactivities" >
                  <tr :key="group.groupId+'_'+subIndex">
                    <td v-if="subIndex === 0 & columns.group.visible "  :rowspan="calculerowspanGroup(group)">{{ group.group }}</td> <!-- 0 A -->
                    <td v-if="columns.subactivity.visible" :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">  {{ subactivity.subactivity }}</td> <!-- 1 B -->
                    <td v-if="columns.subactivity.visible" :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">  {{ subactivity.start_date }}</td> <!-- 2 C -->
                    <td v-if="columns.subactivity.visible" :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">  {{ subactivity.end_date }}</td> <!-- 3 D -->
                    <td v-if="columns.subactivity.visible" :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : '#ffffc1' }">  {{ subactivity.objective_end_date }}</td> <!-- 4 E -->
                    <td v-if="columns.duration.visible" :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">{{ subactivity.weeks_total }}</td> <!-- 5 F -->
                    <td v-if="columns.days_elapsed.visible" :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">
                       {{ subactivity.weeks_elapsed }}
                    </td> <!-- 6 G -->
                    <td v-if="columns.assignment.visible" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">
                      {{ subactivity.assignments[0].assignment }}
                    </td> <!-- 7 H -->
                    <td v-if="columns.unit.visible" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">
                      {{ subactivity.assignments[0].unit }}
                    </td> <!-- 8 I -->
                    <td v-if="columns.projected.visible" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">
                      {{ subactivity.assignments[0].projected }}
                    </td> <!-- 9 J -->
                    <td v-if="columns.executed.visible" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">
                      {{ subactivity.assignments[0].executed }}
                    </td> <!-- 10 K -->
                    <td  v-if="columns.progress.visible" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">
                      {{ subactivity.assignments[0].progress }}
                    </td> <!-- 11 L -->
                    <td  v-if="columns.progress.visible" :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : '#efefef' }">
                      {{ subactivity.projected_subactivity }}
                    </td> <!-- 12 M -->
                    <td  v-if="columns.progress.visible" :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : '#efefef' }">
                      {{ subactivity.executed_subactivity }}
                    </td> <!-- 13 N --> 
                    <td  v-if="columns.progress.visible" :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : '#efefef' }">
                      {{ (subactivity.executed_subactivity * 100 / subactivity.projected_subactivity).toFixed(2) }} %
                    </td> <!-- 14 O -->
                    <td :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">
                      {{ subactivity.assignments[0].ratio_weekly_projected }}
                    </td> <!-- 15 P -->
                    <td :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : '#efefef' }">
                      {{ subactivity.ratio_weekly_projected_subactivity.toFixed(2) }}
                    </td> <!-- 16 Q -->
                    <td :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">
                      {{ subactivity.assignments[0].ratio_weekly_executed }}
                    </td> <!-- 17 R -->
                    <td :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : '#efefef' }">
                      {{ subactivity.ratio_weekly_executed_subactivity.toFixed(2) }}
                    </td> <!-- 18 S -->
                    <td v-if="columns.end_date_estimated.visible" :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : '#efefef' }">
                      {{ endDateEstimated(subactivity) }}
                    </td> <!-- 19 T -->
                    <td :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : '#efefef' }">
                      {{ endDateEstimated(subactivity, true) }}
                    </td> <!-- 20 U -->
                    <td v-if="columns.ratio_objective.visible" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">
                      {{ subactivity.assignments[0].ratio_objective }}
                    </td> <!-- 21 V -->
                    <td v-if="columns.ratio_objective_subactivity.visible" :rowspan="subactivity.assignments.length" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : '#efefef' }">
                      {{ subactivity.ratio_objective_subactivity }}
                    </td> <!-- 22 W -->
                  </tr>

                  <tr v-for="(medicion, medIndex) in subactivity.assignments" :key="'row_'+medicion.assignment_id" v-if="medIndex > 0">
                    <td v-if="columns.assignment.visible" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">{{ medicion.assignment }}</td> <!-- 7 H -->
                    <td v-if="columns.unit.visible" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">{{ medicion.unit }}</td> <!-- 8 I -->
                    <td v-if="columns.projected.visible" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">{{ medicion.projected }}</td> <!-- 9 J -->
                    <td v-if="columns.executed.visible" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">{{ medicion.executed }}</td> <!-- 10 K -->
                    <td v-if="columns.progress.visible" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">{{ medicion.progress }}</td> <!-- 11 L -->
                    <td :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">{{ medicion.ratio_weekly_projected }}</td> <!-- 15 P -->
                    <td :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">{{ medicion.ratio_weekly_executed }}</td> <!-- 17 R -->
                    <td v-if="columns.ratio_objective.visible" :style="{ fontWeight: subactivity.subactivity === 'Total' ? 'bold' : 'inherit', backgroundColor:subactivity.subactivity === 'Total' ? '#F2F2F2' : 'inherit' }">{{ medicion.ratio_objective }}</td> <!-- 21 v -->
                  </tr>

                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>

  
      </div>

    </section>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import axios from 'axios'
  import ProjectAdminQuickButtons from '·/components/project-admin-quick-buttons'
  import Multiselect from 'vue-multiselect'
  import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

  export default {
    components: {
        ProjectAdminQuickButtons,
        Multiselect,
        ScaleLoader
      },
      props: {
      groupIds: {
        type: Array,
        required: true
      },// ids de los grupos seleccionados recibidos por props 
      projectId: {
        type: Number,
        required: true
      },
      objectiveEndDates: {
        type: Object,
        default: () => ({})
      }// objeto con las fechas objetivo de cada actividad recibido por props 
    },

    computed: {

      ...mapGetters({
        navData: "app/navData",
        mobile: 'device/mobile'
      }),

      groupedData() {
        const grouped = {};
        this.data.forEach(item => {
          if (!grouped[item.group]) {
            grouped[item.group] = { group: item.group, subactivities: [] };
          }
          grouped[item.group].subactivities.push(item);
        });
        return Object.values(grouped);
      },

      _columns: function() {
        // return Object.values(this.columns)
        // Object.keys(myObject).map(key => myObject[key]);
        return Object.entries(this.columns).map(([key, value]) => ({ key, title: this.$t(value.title), visible: value.visible }));
      },

      limitShowColumnsSelect() { // cantidad de columnas visibles seleccionadas a mostrar en el multiselect por defecto  8
        return this.mobile.on_mobile ? 3 : 8
      },

    },

    data: () => ({
      kpiGroups: [],
      activities: [],
      newGroup: {
        name: "",
      },
      activitySelected: null,
      loading: false,
      isAddGroup: false,
      isAddActivity: false,
      kpiData:[],
      columns:{
        group: { title: "Grupo", visible: true },
        subactivity: { title: "Subactividad", visible: true },
        duration: { title: "Duración dias", visible: true },
        days_elapsed: { title: "Días transcurridos", visible: true },
        assignment: { title: "Mediciones", visible: true },
        unit: { title: "Unidades", visible: true },
        projected: { title: "Proyectado", visible: true },
        executed: { title: "Unidades ejecutadas", visible: true },
        progress: { title: "Avance actual % por medición", visible: true },
        end_date_estimated: { title: "Fecha fin estimada", visible: true },
        ratio_objective: { title: "Ratio objetivo medicion", visible: true },
        ratio_objective_subactivity: { title: "Ratio objetivo subactividad", visible: true },
      },
      columnsSelected: [],
    }),
      watch: {
        groupIds: 'getTableData',
        projectId: 'getTableData',
        objectiveEndDates: {
          handler: 'getTableData',
          deep: true
        }
      },

    created() {
      let projectName = this.navData.project_name
        ? this.navData.project_name.toUpperCase()
        : "";

      this.$options.subtitle = ["project_actions_page_subtitle", [projectName]];

      this.getTableData()
    },


    mounted(){
      this.columnsSelected = this._columns.filter(column => column.visible == true)

    },

    methods: {

      calculerowspanGroup(group) {
        return group.subactivities.map(subactivity => subactivity.assignments.length).reduce((a, b) => a + b, 0)
        // esto me da la longitud de la sumatoria de subactivities.mediciones.length
      },


      transformData(dataEntrada){
        // Agrupar datos por group y group_id
        const groupedData1 = dataEntrada.reduce((acc, item) => {
          const { group, group_id, subactivity, subactivity_id } = item;

          if (!acc[group]) {
            acc[group] = {
              group: group,
              groupId: group_id,
              subactivities: {}
            };
          }

          if (!acc[group].subactivities[subactivity_id]) {
            acc[group].subactivities[subactivity_id] = {
              subactivity: subactivity,
              duration: item.duration,
              weeks_total: item.weeks_total,
              start_date: item.start_date,
              end_date: item.end_date,
              objective_end_date: item.objective_end_date,
              weeks_elapsed: item.weeks_elapsed,
              end_date_estimated: item.end_date_estimated,
              assignments: [],
              projected_subactivity: 0,
              executed_subactivity: 0,
              ratio_weekly_projected_subactivity: 0,
              ratio_weekly_executed_subactivity: 0,
              ratio_objective_subactivity: 0,
            };
          }

          acc[group].subactivities[subactivity_id].assignments.push({
            assignment: item.assignment,
            assignment_id: item.assignment_id,
            projected: item.projected,
            unit: item.unit,
            executed: item.executed,
            progress: item.progress,
            ratio_objective: item.ratio_objective,
            ratio_weekly_projected: item.ratio_weekly_projected,
            ratio_weekly_executed: item.ratio_weekly_executed,
          });

          if (subactivity === 'Total') {

            // Para la ultima fila "Total" de cada grupo, recopilamos algunos datos
            acc[group].subactivities[subactivity_id].projected_subactivity = item.projected_group;
            acc[group].subactivities[subactivity_id].executed_subactivity = item.executed_group;
            acc[group].subactivities[subactivity_id].ratio_weekly_projected_subactivity = item.projected / item.weeks_total
            acc[group].subactivities[subactivity_id].ratio_weekly_projected = acc[group].subactivities[subactivity_id].ratio_weekly_projected_subactivity
            acc[group].subactivities[subactivity_id].ratio_weekly_executed_subactivity = Number((item.executed / item.weeks_elapsed).toFixed(2))
            acc[group].subactivities[subactivity_id].ratio_objective_subactivity = item.ratio_objective_subactivity;

          } else {

            acc[group].subactivities[subactivity_id].projected_subactivity += parseFloat(item.projected) || 0 ;
            acc[group].subactivities[subactivity_id].executed_subactivity += parseFloat(item.executed) || 0 ;
            acc[group].subactivities[subactivity_id].ratio_weekly_projected_subactivity += parseFloat(item.ratio_weekly_projected) || 0 ;
            acc[group].subactivities[subactivity_id].ratio_weekly_executed_subactivity += parseFloat(item.ratio_weekly_executed) || 0 ;
            acc[group].subactivities[subactivity_id].ratio_objective_subactivity += parseFloat(item.ratio_objective) || 0 ;

          }


          return acc;
        }, {});

        // Convertir el objeto agrupado en un array con la estructura deseada
        const result = Object.keys(groupedData1).map(group => {
          const groupData = groupedData1[group];
          const subactivities = Object.keys(groupData.subactivities).map(subactivity => {
            return groupData.subactivities[subactivity];
          });

          return {
            group: groupData.group,
            groupId: groupData.groupId,
            subactivities: subactivities
          };
        });

        return result;
      },


      _HandleSelectItem(selectedOption, id) {
        this.columns[selectedOption.key].visible = true
      },


      _HandleRemoveItem(removedOption, id) {
        if (this.columns[removedOption.key])
          this.columns[removedOption.key].visible = false
      },


      async generateReport() {
        const { data } = await axios.get('/api/v2/project/' + this.projectId + '/kpi-report', {
          params: {
            groupIds: this.groupIds,
            objectiveEndDates: this.objectiveEndDates
          }
        })
        if (data && data.success) {
          this.$notify.success('report_generated')
          window.open(data.data, '_blank')
        } else {
          console.error('Error generating report', data);
          this.$notify.error('error_loading_data')
        }
      },


      async getTableData() {
        this.loading = true
        const { data } = await axios.get('/api/v2/project/' + this.projectId + '/kpi-table', {
          params: {
            groupIds: this.groupIds,
            objectiveEndDates: this.objectiveEndDates
          }
        })
        if (data && data.success) {
          this.kpiData = this.transformData(data.data)
          this.loading = false
        } else {
          this.$notify.error('error_loading_data')
        }
      },


      endDateEstimated(subactivity, returnDiffInDays = false) {
        // Calculate the number of days to add
        let res = ((subactivity.projected_subactivity - subactivity.executed_subactivity) / subactivity.ratio_weekly_executed_subactivity) * 7;
        // Add 'res' days to current date
        let estimatedEndDate = new Date();
        estimatedEndDate.setDate(estimatedEndDate.getDate() + Math.ceil(res));

        // Opcion retornar diferencia en días entre fecha fin estimada y fecha fin actual
        if (returnDiffInDays) {
          // convertimos end_date dd/mm/yyyy to Date object
          const [endDay, endMonth, endYear] = subactivity.end_date.split('/').map(Number);
          const endDate = new Date(endYear, endMonth - 1, endDay);
          let diffTime = estimatedEndDate - endDate; // diff en milisegundos
          if (diffTime > 0) {
            return Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convertir a días
          } else {
            return 0; // No hay retraso
          }
        }

        // Opcion retornar fecha fin estimada
        // Format as dd/mm/yyyy
        let day = String(estimatedEndDate.getDate()).padStart(2, '0');
        let month = String(estimatedEndDate.getMonth() + 1).padStart(2, '0');
        let year = estimatedEndDate.getFullYear();
        return `${day}/${month}/${year}`;
      },

    }
  };
</script>

<style scoped>
  table {
    width: 100%;
    border-collapse: collapse;
  }

  th, td {
    border: 1px solid black;
    padding: 8px;
    vertical-align: middle;
    font-size: 12px;
  }

  th {
    text-align: center;
    background-color: #96bde7;
    color: rgb(45, 45, 45);
  }

  .table-container {
    overflow-x: auto;
  }
</style>
